import type { WidgetProps } from "../registry";
import type { CreateTargetDraft } from "../../../generated-api";

export type TargetsSaveResult = {
  confirmed: boolean;
};

export function TargetsSaveWidget({
  payload,
  onComplete,
}: WidgetProps<CreateTargetDraft>) {
  const targets = payload ?? [];

  return (
    <div className="flex flex-col gap-3 mt-1 border border-border-subtle rounded-xl p-3 text-sm">
      <div className="text-xs font-medium text-text-secondary">
        Targets to save ({targets.length})
      </div>
      <div className="flex flex-col gap-2">
        {targets.map((t, idx) => (
          <div
            key={t.id ?? idx}
            className="flex flex-col gap-0.5 border border-border-subtle/60 rounded-lg p-2"
          >
            <div className="text-text-primary font-medium">
              {t.capacityQualitative} — {t.kineticDomain}
            </div>
            <div className="text-xs text-text-secondary">
              <span className="font-medium text-text-primary">Desired:</span>{" "}
              {t.targetState}
            </div>
            {t.targetStateNumeric && (
              <div className="text-xs text-text-secondary">
                <span className="font-medium text-text-primary">Metric:</span>{" "}
                {t.targetStateNumeric.metric} = {t.targetStateNumeric.value}{" "}
                {t.targetStateNumeric.unit}
              </div>
            )}
            {t.biomechanicJustification && (
              <div className="text-xs text-text-secondary">
                <span className="font-medium text-text-primary">Why:</span>{" "}
                {t.biomechanicJustification}
              </div>
            )}
            {t.nextTarget && (
              <div className="text-xs text-text-secondary font-mono">
                <span className="font-medium text-text-primary not-italic font-sans">
                  → supports:
                </span>{" "}
                {t.nextTarget.slice(0, 8)}…
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="flex gap-2 pt-1">
        <button
          type="button"
          onClick={() =>
            onComplete({ confirmed: true } satisfies TargetsSaveResult)
          }
          className="px-4 py-2 text-sm font-medium rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 transition-colors"
        >
          Save targets
        </button>
        <button
          type="button"
          onClick={() =>
            onComplete({ confirmed: false } satisfies TargetsSaveResult)
          }
          className="px-4 py-2 text-sm font-medium rounded-lg border border-border-subtle text-text-primary hover:bg-bg-secondary transition-colors"
        >
          Not yet
        </button>
      </div>
    </div>
  );
}
